import { render, staticRenderFns } from "./AboutTab.vue?vue&type=template&id=08aa6fe6"
import script from "./AboutTab.vue?vue&type=script&lang=js"
export * from "./AboutTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports